import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'mhxBol';

const mapStateToProps = (state, ownProps) => {
	let mhxBols;
	let mhxBol;
	let mhxBolId;

	if (state.lists.mhxBolIds) {
		mhxBols = _.map(state.lists.mhxBolIds, (id) => state.maps.mhxBol[id]);
	}

	if (ownProps.mhxBol) {
		mhxBol = ownProps.mhxBol;
	} else {
		mhxBolId = ownProps.mhxBolId
			? ownProps.mhxBolId
			: _.get(ownProps, ['match', 'params', 'mhxBolId']);
		mhxBol = _.get(state.maps, ['mhxBol', mhxBolId]);
	}

	return {
		mhxBol,
		mhxBols,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		supplierMap: state.maps.supplier,
		stationDeliveryMap: state.maps.stationDelivery,
		stationMap: state.maps.station,
	};
};

const search = (p = {}) => {
	const { afterDateTime, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
			},
			dispatch,
			callback,
		});
	};
};

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getMhxBol: get,
			mhxBolSearch: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
